import React, { useEffect, useState } from 'react'
import { callGetApi, callPostApi, callPutApi } from '../api/ApiCaller';
import { GET_BANK_DETAILS_GET, PLAYER_ADDRESS_UPDATE_POST, PLAYER_PROFILE_GET, PLAYER_PROFILE_UPDATE_POST, SAVE_BANK_DETAILS_POST } from '../api/ApiConst';
import { STATUS } from '../utils/Constants';
import ModalBox from './common/ModalBox';

export const PersonalData = () => {

    const [profileDetails, setProfileDetails] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editFormData, setEditFormData] = useState({});
    const [editAddress, setEditAddress] = useState(false);
    const [showEditAddressModal, setShowEditAddressModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [showBankDetail, setShowBankDetail] = useState(false);
    const [bankDetail, setBankDetail] = useState(false);
    const [bankDetailID, setBankDetailID] = useState(null);



    useEffect(() => {
        getPlayerDetails();
        getBankDetails();
    }, [bankDetailID]);


    const getPlayerDetails = () => {
        setIsLoading(true);
        callGetApi(PLAYER_PROFILE_GET, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                setProfileDetails({ ...response.responsePacket, dateOfBirth: formatDateForDisplay(response.responsePacket.dateOfBirth) });
                setEditFormData({ ...response.responsePacket, dateOfBirth: formatDateForDisplay(response.responsePacket.dateOfBirth) });
            }
            setIsLoading(false);
        });
    };

    function getBankDetails() {
        // if (bankDetailID) {
        callGetApi(GET_BANK_DETAILS_GET, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                setBankDetail(response.responsePacket);
            }
        });
        // } else {
        //     setBankDetail({
        //         bank: "",
        //         fullName: "",
        //         cpf: "",
        //         agency: "",
        //         account: "",
        //         acountType: "",
        //         pixKey: "",
        //     });
        // }
    }

    const handleEditClick = () => {
        setEditFormData({ ...profileDetails });
        setShowEditModal(true);
    }

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;


        setEditFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

    }
    const convertDateForInput = (dateString) => {
        if (!dateString) return '';

        // If date is in dd/mm/yyyy format, convert to yyyy-mm-dd for input field
        if (dateString.includes('/') && dateString.split('/').length === 3) {
            const parts = dateString.split('/');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
        }

        // If date is already in yyyy-mm-dd format, return as is
        if (dateString.includes('-') && dateString.split('-').length === 3) {
            return dateString;
        }

        return dateString;
    }

    const formatDateForDisplay = (dateString) => {
        if (!dateString) return '';

        // If date is in dd-mm-yyyy format, parse it manually
        if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
            const [day, month, year] = dateString.split('-');
            return `${year}-${month}-${day}`; // Convert to yyyy-mm-dd
        }

        // If it's a Date object or ISO string, convert to dd-mm-yyyy
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
        } catch (error) {
            return dateString;
        }
    };

    const formatDateForAPI = (dateString) => {
        if (!dateString) return '';

        // Convert dd-mm-yyyy to yyyy-mm-dd for API
        if (dateString.includes('-') && dateString.split('-').length === 3) {
            const parts = dateString.split('-');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
        }

        return dateString;
    }
    const [form, setForm] = useState({
        bank: "",
        fullName: "",
        cpf: "",
        agency: "",
        account: "",
        type: "",
        pixKey: "",
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const handleSave = () => {
        // Extract only the fields present in the profile form
        const profileFields = {
            fullName: editFormData.fullName,
            gender: editFormData.gender,
            dateOfBirth: formatDateForAPI(editFormData.dateOfBirth),
            nationality: editFormData.nationality,
            cpf: editFormData.cpf,
            email: editFormData.email,
            phone: editFormData.phone,
            marketingConsent: editFormData.marketingConsent
        };


        callPostApi(PLAYER_PROFILE_UPDATE_POST, profileFields, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                setProfileDetails(editFormData);
                setShowEditModal(false);
                getPlayerDetails();
            }
        });
    };

    const handleBankDetailsModalChange = (e) => {
        const { name, value } = e.target;
        setBankDetail(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSaveBankDetails = () => {
        // console.log(firstname, "first")
        // console.log(bankDetail, "bankdetail")
        const payload = {
            bank: bankDetail.bank,
            fullName: bankDetail.fullName,
            cpf: bankDetail.cpf,
            agency: bankDetail.agency,
            account: bankDetail.account,
            accountType: bankDetail.accountType,
            pixKey: bankDetail.pixKey

        };

        callPostApi(SAVE_BANK_DETAILS_POST, payload, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                setBankDetailID(response.responsePacket);
                setShowBankDetail(false);
                getPlayerDetails();
            }
        });
    }



    const handleCancel = () => {
        setShowBankDetail(false);
    }

    const toggleEditModal = () => {
        setShowEditModal(!showEditModal);
    }
    const handleEditAddressClick = () => {
        setEditAddress({ ...profileDetails });
        setShowEditAddressModal(true);
    }
    const toggleEditAddressModal = () => {
        setShowEditAddressModal(!showEditAddressModal);
    }
    const handleSaveAddress = () => {
        // Extract only address fields and marketing consent
        const addressFields = {
            street: editAddress.street,
            number: editAddress.number,
            complement: editAddress.complement,
            neighborhood: editAddress.neighborhood,
            cep: editAddress.cep,
            city: editAddress.city,
            state: editAddress.state,
            country: editAddress.country,
            marketingConsent: editAddress.marketingConsent
        };

        callPostApi(PLAYER_ADDRESS_UPDATE_POST, addressFields, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                setProfileDetails(editAddress);
                setShowEditAddressModal(false);
                getPlayerDetails();
            }
        });
    }

    return (
        <>
            {isLoading ? (
                <div className='main-div-content'>
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="mt-3 text-light">
                                <strong>Loading your profile information...</strong>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className='main-div-content'>
                    <div className="personal-data-row">
                        <div className="personal-data-box flex-1">
                            <div className="personal-data-header">
                                <div>
                                    <strong>Personal Information</strong>
                                    <span className="status filled"><svg width="16" height="16" viewBox="0 0 16 16" style={{ verticalAlign: 'middle', marginRight: 4 }}>
                                        <circle cx="8" cy="8" r="8" fill="#15803d" />
                                        <path d="M5 8.5l2 2 4-4" stroke="#fff" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>Filled</span>
                                </div>
                                <button className="edit-btn" onClick={handleEditClick}>Edit</button>
                            </div>
                            <div className="personal-data-content">
                                {profileDetails?.fullName} - {formatDateForDisplay(profileDetails?.dateOfBirth)}
                            </div>
                        </div>
                        <div className="personal-data-box flex-1">
                            <div className="personal-data-header">
                                <div>
                                    <strong>Document</strong>
                                    {(profileDetails?.cpf && profileDetails?.cpf !== '') ? <span className="status verified"><svg width="16" height="16" viewBox="0 0 16 16" style={{ verticalAlign: 'middle', marginRight: 4 }}>
                                        <circle cx="8" cy="8" r="8" fill="#15803d" />
                                        <path d="M5 8.5l2 2 4-4" stroke="#fff" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>Verified</span> : <span className="status pending"><svg width="16" height="16" viewBox="0 0 16 16" style={{ verticalAlign: 'middle', marginRight: 4 }}>
                                        <circle cx="8" cy="8" r="8" fill="#b91c1c" />
                                        <line x1="5.5" y1="5.5" x2="10.5" y2="10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                                        <line x1="10.5" y1="5.5" x2="5.5" y2="10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                                    </svg>Pending</span>}
                                </div>

                            </div>
                            <div className="personal-data-content">
                                {profileDetails?.cpf}
                            </div>
                        </div>
                    </div>
                    <div className="personal-data-row">
                        <div className="personal-data-box flex-1">
                            <div>
                                <strong>Email</strong>
                                <span className="status verified"><svg width="16" height="16" viewBox="0 0 16 16" style={{ verticalAlign: 'middle', marginRight: 4 }}>
                                    <circle cx="8" cy="8" r="8" fill="#15803d" />
                                    <path d="M5 8.5l2 2 4-4" stroke="#fff" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>Verified</span>
                            </div>
                            <div className="personal-data-content">
                                {profileDetails?.email}
                            </div>
                        </div>
                        <div className="personal-data-box flex-1">
                            <div>
                                <strong>Phone</strong>
                                <span className="status verified"><svg width="16" height="16" viewBox="0 0 16 16" style={{ verticalAlign: 'middle', marginRight: 4 }}>
                                    <circle cx="8" cy="8" r="8" fill="#15803d" />
                                    <path d="M5 8.5l2 2 4-4" stroke="#fff" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>Verified</span>
                            </div>
                            <div className="personal-data-content">
                                {profileDetails?.phone}
                            </div>
                        </div>
                    </div>
                    <div className='personal-data-row'>
                        <div className="personal-data-box flex-2">
                            <div className='personal-data-header'>
                                <strong>
                                    Bank account details for withdrawal requests
                                </strong>
                                <button
                                    className="edit-btn" onClick={setShowBankDetail}

                                >
                                    Edit
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="personal-data-row">
                        <div className="personal-data-box flex-2">
                            <div className="personal-data-header">
                                <div>
                                    <strong>Address</strong>
                                    <span className="status filled"><svg width="16" height="16" viewBox="0 0 16 16" style={{ verticalAlign: 'middle', marginRight: 4 }}>
                                        <circle cx="8" cy="8" r="8" fill="#15803d" />
                                        <path d="M5 8.5l2 2 4-4" stroke="#fff" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>Filled</span>
                                </div>
                                <button className="edit-btn" onClick={handleEditAddressClick}>Edit</button>
                            </div>

                            <div className="personal-data-content">
                                {profileDetails?.street}, {profileDetails?.number}, {profileDetails?.complement}, {profileDetails?.neighborhood}, {profileDetails?.cep}, {profileDetails?.city}, {profileDetails?.state}
                            </div>
                        </div>
                    </div>
                    <div className="personal-data-box">
                        <strong>News and Promotions</strong>
                        <div className="news-checkbox-row">
                            <input type="checkbox" id="news" checked={profileDetails?.marketingConsent} />
                            <label htmlFor="news">
                                I authorize you to send me news and promotions by email, SMS or WhatsApp.
                            </label>
                        </div>
                    </div>
                    <div className="last-login">
                        Last login : 07/15/2025 - 17:23
                    </div>
                </div>
            )}

            {/* Edit Personal Data Modal */}
            <ModalBox
                show={showEditModal}
                toggleModel={toggleEditModal}
                modalClass="personal-data-edit-modal"
            >
                <div className="modal-dialog updateUserDetails modal-dialog-centered modal-lg">
                    <div className="modal-content" style={{ backgroundColor: '#2a2a2a', border: '1px solid #444' }}>
                        <div className=" updateUserDetails position-relative" style={{ backgroundColor: '#2a2a2a', borderBottom: '1px solid #444' }}>
                            <span
                                className="btn-close"
                                onClick={toggleEditModal}
                                style={{ color: '#fff' }}
                            />
                        </div>

                        <div className="modal-body updateUserDetails text-center" style={{ backgroundColor: '#2a2a2a' }}>
                            <div className="p-4">
                                <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
                                    {/* Personal Information Section */}
                                    <div className="form-section mb-4">
                                        <div className="row">
                                            <div className="col-12 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="fullName" className="form-label fw-bold text-white mb-2">Full Name *</label>
                                                    <input
                                                        type="text"
                                                        id="fullName"
                                                        name="fullName"
                                                        className="form-control"
                                                        value={editFormData.fullName || ''}
                                                        onChange={handleInputChange}
                                                        required
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="gender" className="form-label fw-bold text-white mb-2">Gender *</label>
                                                    <select
                                                        id="gender"
                                                        name="gender"
                                                        className="form-control"
                                                        value={editFormData.gender || ''}
                                                        onChange={handleInputChange}
                                                        required
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    >
                                                        <option value="">Select Gender</option>
                                                        <option value="MALE">Male</option>
                                                        <option value="FEMALE">Female</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="dateOfBirth" className="form-label fw-bold text-white mb-2">Date of Birth *</label>
                                                    <div className="position-relative">
                                                        <input
                                                            type="date"
                                                            id="dateOfBirth"
                                                            name="dateOfBirth"
                                                            className="form-control"
                                                            value={editFormData.dateOfBirth}
                                                            onChange={handleInputChange}
                                                            placeholder="dd/mm/yyyy"
                                                            required
                                                            style={{
                                                                backgroundColor: '#1a1a1a',
                                                                border: '1px solid #666',
                                                                color: '#e0e0e0',
                                                                borderRadius: '4px',
                                                                padding: '12px 16px',
                                                                paddingRight: '40px'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="cpf" className="form-label fw-bold text-white mb-2">CPF *</label>
                                                    <input
                                                        type="text"
                                                        id="cpf"
                                                        name="cpf"
                                                        className="form-control"
                                                        value={editFormData.cpf || ''}
                                                        onChange={handleInputChange}
                                                        placeholder="000.000.000-00"
                                                        required
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-6 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="email" className="form-label fw-bold text-white mb-2">Email</label>
                                                    <div className="position-relative">
                                                        <input
                                                            type="email"
                                                            id="email"
                                                            name="email"
                                                            className="form-control"
                                                            value={editFormData.email}
                                                            onChange={handleInputChange}
                                                            style={{
                                                                backgroundColor: '#1a1a1a',
                                                                border: '1px solid #666',
                                                                color: '#e0e0e0',
                                                                borderRadius: '4px',
                                                                padding: '12px 16px'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="phone" className="form-label fw-bold text-white mb-2">Phone</label>
                                                    <div className="position-relative">
                                                        <input
                                                            type="phone"
                                                            id="phone"
                                                            name="phone"
                                                            className="form-control"
                                                            value={editFormData.phone}
                                                            onChange={handleInputChange}
                                                            style={{
                                                                backgroundColor: '#1a1a1a',
                                                                border: '1px solid #666',
                                                                color: '#e0e0e0',
                                                                borderRadius: '4px',
                                                                padding: '12px 16px'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="nationality" className="form-label fw-bold text-white mb-2">Nationality *</label>
                                                    <select
                                                        id="nationality"
                                                        name="nationality"
                                                        className="form-control"
                                                        value={editFormData.nationality || ''}
                                                        onChange={handleInputChange}
                                                        required
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    >
                                                        <option value="">Select Nationality</option>
                                                        <option value="Brasil">Brazil</option>
                                                        <option value="Argentina">Argentina</option>
                                                        <option value="Chile">Chile</option>
                                                        <option value="Colombia">Colombia</option>
                                                        <option value="Mexico">Mexico</option>
                                                        <option value="Peru">Peru</option>
                                                        <option value="Uruguay">Uruguay</option>
                                                        <option value="Venezuela">Venezuela</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="d-flex justify-content-center gap-3 mt-4">
                                        <button type="button" className="cancel-btn" onClick={handleCancel}>
                                            Cancel
                                        </button>
                                        <button type="submit" className="submit-btn" >
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBox>
            <ModalBox
                show={showEditAddressModal}
                toggleModel={toggleEditAddressModal}
                modalClass="personal-data-edit-modal"
            >
                <div className="modal-dialog updateUserDetails modal-dialog-centered modal-lg">
                    <div className="modal-content" style={{ backgroundColor: '#2a2a2a', border: '1px solid #444' }}>
                        <div className="updateUserDetails position-relative" style={{ backgroundColor: '#2a2a2a', borderBottom: '1px solid #444' }}>
                            <span
                                className="btn-close"
                                onClick={toggleEditAddressModal}
                                style={{ color: '#fff' }}
                            />
                        </div>

                        <div className="modal-body updateUserDetails text-center" style={{ backgroundColor: '#2a2a2a' }}>
                            <div className="p-4">
                                <form onSubmit={(e) => { e.preventDefault(); handleSaveAddress(); }}>
                                    {/* Address Section */}
                                    <div className="form-section mb-4">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="country" className="form-label fw-bold text-white mb-2">Country *</label>
                                                    <select
                                                        id="country"
                                                        name="country"
                                                        className="form-control"
                                                        value={editAddress.country || ''}
                                                        onChange={(e) => setEditAddress(prev => ({ ...prev, country: e.target.value }))}
                                                        required
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    >
                                                        <option value="">Select Country</option>
                                                        <option value="Brasil">Brazil</option>
                                                        <option value="Argentina">Argentina</option>
                                                        <option value="Chile">Chile</option>
                                                        <option value="Colombia">Colombia</option>
                                                        <option value="Mexico">Mexico</option>
                                                        <option value="Peru">Peru</option>
                                                        <option value="Uruguay">Uruguay</option>
                                                        <option value="Venezuela">Venezuela</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="cep" className="form-label fw-bold text-white mb-2">ZIP Code</label>
                                                    <input
                                                        type="text"
                                                        id="cep"
                                                        name="cep"
                                                        className="form-control"
                                                        value={editAddress.cep || ''}
                                                        onChange={(e) => setEditAddress(prev => ({ ...prev, cep: e.target.value }))}
                                                        placeholder="00000-000"
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="street" className="form-label fw-bold text-white mb-2">Street</label>
                                                    <input
                                                        type="text"
                                                        id="street"
                                                        name="street"
                                                        className="form-control"
                                                        value={editAddress.street || ''}
                                                        onChange={(e) => setEditAddress(prev => ({ ...prev, street: e.target.value }))}
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="number" className="form-label fw-bold text-white mb-2">Number</label>
                                                    <input
                                                        type="text"
                                                        id="number"
                                                        name="number"
                                                        className="form-control"
                                                        value={editAddress.number || ''}
                                                        onChange={(e) => setEditAddress(prev => ({ ...prev, number: e.target.value }))}
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="complement" className="form-label fw-bold text-white mb-2">Complement</label>
                                                    <input
                                                        type="text"
                                                        id="complement"
                                                        name="complement"
                                                        className="form-control"
                                                        value={editAddress.complement || ''}
                                                        onChange={(e) => setEditAddress(prev => ({ ...prev, complement: e.target.value }))}
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="neighborhood" className="form-label fw-bold text-white mb-2">Neighborhood</label>
                                                    <input
                                                        type="text"
                                                        id="neighborhood"
                                                        name="neighborhood"
                                                        className="form-control"
                                                        value={editAddress.neighborhood || ''}
                                                        onChange={(e) => setEditAddress(prev => ({ ...prev, neighborhood: e.target.value }))}
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="city" className="form-label fw-bold text-white mb-2">City *</label>
                                                    <input
                                                        type="text"
                                                        id="city"
                                                        name="city"
                                                        className="form-control"
                                                        value={editAddress.city || ''}
                                                        onChange={(e) => setEditAddress(prev => ({ ...prev, city: e.target.value }))}
                                                        required
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group text-start">
                                                    <label htmlFor="state" className="form-label fw-bold text-white mb-2">State *</label>
                                                    <select
                                                        id="state"
                                                        name="state"
                                                        className="form-control"
                                                        value={editAddress.state || ''}
                                                        onChange={(e) => setEditAddress(prev => ({ ...prev, state: e.target.value }))}
                                                        required
                                                        style={{
                                                            backgroundColor: '#1a1a1a',
                                                            border: '1px solid #666',
                                                            color: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            padding: '12px 16px'
                                                        }}
                                                    >
                                                        <option value="">Select State</option>
                                                        <option value="São Paulo">São Paulo</option>
                                                        <option value="Rio de Janeiro">Rio de Janeiro</option>
                                                        <option value="Minas Gerais">Minas Gerais</option>
                                                        <option value="Bahia">Bahia</option>
                                                        <option value="Paraná">Paraná</option>
                                                        <option value="Rio Grande do Sul">Rio Grande do Sul</option>
                                                        <option value="Pernambuco">Pernambuco</option>
                                                        <option value="Ceará">Ceará</option>
                                                        <option value="Pará">Pará</option>
                                                        <option value="Santa Catarina">Santa Catarina</option>
                                                        <option value="Goiás">Goiás</option>
                                                        <option value="Maranhão">Maranhão</option>
                                                        <option value="Espírito Santo">Espírito Santo</option>
                                                        <option value="Paraíba">Paraíba</option>
                                                        <option value="Rio Grande do Norte">Rio Grande do Norte</option>
                                                        <option value="Mato Grosso">Mato Grosso</option>
                                                        <option value="Alagoas">Alagoas</option>
                                                        <option value="Piauí">Piauí</option>
                                                        <option value="Distrito Federal">Distrito Federal</option>
                                                        <option value="Mato Grosso do Sul">Mato Grosso do Sul</option>
                                                        <option value="Sergipe">Sergipe</option>
                                                        <option value="Rondônia">Rondônia</option>
                                                        <option value="Tocantins">Tocantins</option>
                                                        <option value="Acre">Acre</option>
                                                        <option value="Amapá">Amapá</option>
                                                        <option value="Roraima">Roraima</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Marketing Consent Section */}
                                    <div className="form-section mb-4">
                                        <h5 className="text-light mb-3">Marketing Preferences</h5>
                                        <div className="form-group text-start">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    id="marketingConsent"
                                                    name="marketingConsent"
                                                    className="form-check-input"
                                                    checked={editAddress.marketingConsent || false}
                                                    onChange={(e) => setEditAddress(prev => ({ ...prev, marketingConsent: e.target.checked }))}
                                                />
                                                <label className="form-check-label fw-bold text-light" htmlFor="marketingConsent">
                                                    I authorize you to send me news and promotions by email, SMS or WhatsApp.
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="d-flex justify-content-center gap-3 mt-4">
                                        <button type="button" className="cancel-btn" onClick={toggleEditAddressModal} >
                                            Cancel
                                        </button>
                                        <button type="submit" className="submit-btn" >
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBox>
            <ModalBox
                show={showBankDetail}
                toggleModel={setProfileDetails}
                modalClass="personal-data-edit-modal"
            >
                <div className="modal-dialog updateUserDetails modal-dialog-centered modal-lg">
                    <div className="modal-content" style={{ backgroundColor: '#2a2a2a', border: '1px solid #444' }}>
                        <div className=" updateUserDetails position-relative" style={{ backgroundColor: '#2a2a2a', borderBottom: '1px solid #444' }}>
                            <span
                                className="btn-close"
                                onClick={() => setShowBankDetail(false)}
                                style={{ color: '#fff' }}
                            />
                        </div>

                        <div className="modal-body updateUserDetails text-center" style={{ backgroundColor: '#2a2a2a' }}>
                            <div className="bank-details-modal">
                                <h2 className="title">Bank Details</h2>
                                <form className="bank-details-form mt-3" autoComplete="off" onSubmit={(e) => { e.preventDefault(); handleSaveBankDetails(); }}>
                                    <div className="form-group row mb-3">
                                        <label className="col-4 form-label">
                                            <span className="label-bold">BANK:</span>
                                        </label>
                                        <div className="col-8">
                                            <input
                                                type="text"
                                                name="bank"
                                                className="form-control"
                                                value={bankDetail.bank}
                                                onChange={handleBankDetailsModalChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row mb-3">
                                        <label className="col-4 form-label">
                                            <span>Account Holder's Full Name:</span>
                                        </label>
                                        <div className="col-8">
                                            <input
                                                type="text"
                                                name="fullName"
                                                className="form-control"
                                                value={bankDetail.fullName}
                                                onChange={handleBankDetailsModalChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row mb-3">
                                        <label className="col-4 form-label">
                                            <span>CPF:</span>
                                        </label>
                                        <div className="col-8">
                                            <input
                                                type="text"
                                                name="cpf"
                                                className="form-control"
                                                value={bankDetail.cpf}
                                                onChange={handleBankDetailsModalChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row mb-3">
                                        <label className="col-4 form-label">
                                            <span>Agency:</span>
                                        </label>
                                        <div className="col-8">
                                            <input
                                                type="text"
                                                name="agency"
                                                className="form-control"
                                                value={bankDetail.agency}
                                                onChange={handleBankDetailsModalChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row mb-3">
                                        <label className="col-4 form-label">
                                            <span>Account:</span>
                                        </label>
                                        <div className="col-8">
                                            <input
                                                type="text"
                                                name="account"
                                                className="form-control"
                                                value={bankDetail.account}
                                                onChange={handleBankDetailsModalChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row mb-3">
                                        <label className="col-4 form-label">
                                            <span>Account Type:</span>
                                        </label>
                                        <div className="col-8">
                                            <input
                                                type="text"
                                                name="accountType"
                                                className="form-control"
                                                value={bankDetail.accountType}
                                                onChange={handleBankDetailsModalChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row mb-3">
                                        <label className="col-4 form-label">
                                            <span>PIX Key:</span>
                                        </label>
                                        <div className="col-8">
                                            <input
                                                type="text"
                                                name="pixKey"
                                                className="form-control"
                                                value={bankDetail.pixKey}
                                                onChange={handleBankDetailsModalChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center gap-3 mt-4">
                                        <button type="button" className="cancel-btn" onClick={handleCancel}>
                                            Cancel
                                        </button>
                                        <button type="submit" className="submit-btn" >
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBox>
        </>
    )
}
